import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { Trad, BaseComponent } from "../components/";
import {
    TipoCampoStringa,
    TipoCampoTesto,
    TipoCampoData,
    TipoCampoImporto,
    TipoCampoPercentuale,
    TipoCampoTipo,
    CampoMultiSelezione,
    CampoCheckBox,
    CampoMultiInfo,
    InputAnagraficaBreve,
    TipoCampoInfo
} from "../components/";

export class CGruppoPolizza {
    Numero: number = 0;
    Titolo: string = "";
    Dati: React.ReactNode[] = [];

    constructor(numero: number, titolo: string, dati: React.ReactNode[]) {
        this.Numero = numero;
        this.Titolo = titolo;
        this.Dati = dati;
    }
}

export class CAlberaturaDati {
    Elementi: CGruppo[] = [];
}

export class CGruppo {
    Nome: string = "";
    Elementi: CNodo[] = [];
}

export class CNodo {
    Nome: string = "";
    Elementi: any[] = [];
}

interface ICampiPolizzaProps {
    Info: { [I: string]: Dati.CInfoCampo };
    DatoPolizza: any;
    Identificatore: string;
    Limiti: Dati.Dictionary<number>;
    OnChange: (e: React.FormEvent<any> | string, valore?: any, changedFields?: Dati.Dictionary<boolean>) => any;
    OnChangeDeroga: (e: React.FormEvent<any>, tipo: string, verso: string) => any;
    OnBlur: (e: React.FormEvent<any> | string, valore: any) => any;
    Gruppo: string;
    Riga?: number;
    DimensioneGrafica?: number;
    Abilitato?: boolean;
    ConfirmedSteps?: string[];
    OnStepConfirmation: (id: string) => void;
    MaxClient? : number;
}
interface ICampiPolizzaState {
    CurrentStep: number;
}

export class CampiPolizza extends BaseComponent<ICampiPolizzaProps, ICampiPolizzaState> {
    private _Identificatore: string = "";
    private _Abilitato: boolean = true;
    private _WizardSteps: string[] = [];

    public static defaultProps: Partial<ICampiPolizzaProps> = {
        OnStepConfirmation: () => {}
    };

    public constructor(props: any) {
        super(props);
        this.state = { CurrentStep: 0 };
    }

    private CreaListaCampi(
        info: { [I: string]: Dati.CInfoCampo },
        datoPolizza: any,
        identificatore: string,
        limiti: Dati.Dictionary<number>,
        onChange: (e: React.FormEvent<any> | string, valore?: any) => any,
        onChangeDeroga: (e: React.FormEvent<any>, tipo: string, verso: string) => any,
        onBlur: (e: React.FormEvent<any> | string, valore: any) => any,
        gruppo: string,
        abilitato: boolean,
        riga?: number
    ): React.ReactNode {
        let LC: any[] = [];
        let showScoperto = true;
        let AlberoElementi: CAlberaturaDati = new CAlberaturaDati();
        let Gruppo: CGruppo = new CGruppo();
        Gruppo.Nome = gruppo;
        let SottoGruppo: CNodo = new CNodo();

        SottoGruppo.Nome = "";
        if (identificatore != "") this._Identificatore = identificatore + ".";

        let index: number = 0;
        for (var I in info) {
            index++;
            if (info[I].Gruppo != Gruppo.Nome && Gruppo.Nome != "") continue;

            if (info[I].SottoGruppo != SottoGruppo.Nome) {
                if (SottoGruppo.Nome != "") Gruppo.Elementi.push(SottoGruppo);

                SottoGruppo = new CNodo();
                SottoGruppo.Nome = info[I].SottoGruppo;
            }

            if (info[I].Gruppo != Gruppo.Nome) {
                if (Gruppo.Nome != "") AlberoElementi.Elementi.push(Gruppo);

                Gruppo = new CGruppo();
                Gruppo.Nome = info[I].Gruppo;
            }

            let parametri: any = JSON.parse(info[I].ParametriJSON);
            let classeDiv: string = "";

            if (parametri != undefined && parametri.DimensioneGrafica != undefined) {
                classeDiv = Glob.DimensioneCSS(parametri.DimensioneGrafica);
            } else {
                if (this.props.DimensioneGrafica != undefined) {
                    classeDiv = Glob.DimensioneCSS(this.props.DimensioneGrafica);
                } else {
                    classeDiv = Glob.DimensioneCSS(6);
                }
            }

            SottoGruppo.Elementi.push(
                <div className={classeDiv} key={I}>
                    <div>
                        {(() => {
                            let Valore: any;
                            for (var P in datoPolizza) {
                                if (P == info[I].Campo) {
                                    Valore = (datoPolizza as any)[P];
                                    if (parametri != null && parametri.Default != undefined && (Valore == 0 || Valore == "")) {
                                        Valore = parametri.Default;
                                        datoPolizza[P] = Valore;
                                    }
                                }
                                if (info[I].Campo == "implantologiaOsteointegrata")
                                {
                                    showScoperto = Valore;
                                }
                            }

                            let Parametri: any = JSON.parse(info[I].ParametriJSON);

                            switch (info[I].ID_TipoCampo) {
                                case 1: //Intero
                                case 2: //Stringa
                                    return (
                                        <TipoCampoStringa
                                            DerogaVerso={info[I].DerogaVerso}
                                            Derogabile={info[I].Derogabile}
                                            CampoDatabase={info[I].Campo}
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={info[I]}
                                            OnChange={e => onChange(e)}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 11: //Testo
                                    return (
                                        <TipoCampoTesto
                                            DerogaVerso={info[I].DerogaVerso}
                                            Derogabile={info[I].Derogabile}
                                            CampoDatabase={info[I].Campo}
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={info[I]}
                                            OnChange={e => onChange(e)}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 9: //Importo
                                    return (
                                        <TipoCampoImporto
                                            DerogaVerso={info[I].DerogaVerso}
                                            Derogabile={info[I].Derogabile}
                                            CampoDatabase={info[I].Campo}
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={info[I]}
                                            OnChange={e => onChange(e)}
                                            Massimo={limiti[info[I].Campo + "MAX"]}
                                            Minimo={limiti[info[I].Campo + "MIN"]}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            OnBlur={this.props.OnBlur}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 7: //Tipo
                                    if (info[I].Campo == "NumeroAssicurati") {
                                        if (this.props.MaxClient != 1) {
                                            return (
                                                <TipoCampoStringa
                                                    OnChange={() => {
                                                    }}
                                                    Valore={Valore}
                                                    InfoCampo={info[I]}
                                                    Campo={this._Identificatore + info[I].Campo}
                                                    OnChangeDeroga={onChangeDeroga}
                                                    Scrittura={false}
                                                />
                                            );
                                        }
                                        return;
                                    }
                                    return (
                                        <TipoCampoTipo
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={info[I]}
                                            OnChange={onChange}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            OnBlur={this.props.OnBlur}
                                            Scrittura={info[I].Campo == "NumeroAssicurati" ? false : abilitato}
                                        />
                                    );
                                case 10: //Percentuale
                                    return (
                                        <TipoCampoPercentuale
                                            DerogaVerso={info[I].DerogaVerso}
                                            Derogabile={info[I].Derogabile}
                                            CampoDatabase={info[I].Campo}
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={info[I]}
                                            OnChange={e => onChange(e)}
                                            Massimo={limiti[info[I].Campo + "MAX"]}
                                            Minimo={limiti[info[I].Campo + "MIN"]}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 3: //Data
                                    return (
                                        <TipoCampoData
                                            DerogaVerso={info[I].DerogaVerso}
                                            Derogabile={info[I].Derogabile}
                                            CampoDatabase={info[I].Campo}
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Glob.DataValore(Valore)}
                                            InfoCampo={info[I]}
                                            OnChange={onChange}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 12: //MultiSelezione
                                    return (
                                        <div hidden={!showScoperto}>
                                            <CampoMultiSelezione
                                                Id={this._Identificatore + info[I].Campo}
                                                Name={this._Identificatore + info[I].Campo}
                                                Valori={Valore == "" ? info[I].TipoJSON : Valore}
                                                OnChange={onChange}
                                                Grafica={Parametri.Grafica != undefined ? Parametri.Grafica : "Standard"}
                                                BloccoAltezza={Parametri.BloccoAltezza}
                                                Scrittura={abilitato}
                                                Etichetta={info[I].Etichetta}
                                            />
                                        </div>
                                    );
                                case 13: //MultiInfo
                                    return (
                                        <CampoMultiInfo
                                            Id={this._Identificatore + info[I].Campo}
                                            Name={this._Identificatore + info[I].Campo}
                                            Valori={Valore}
                                            OnChange={onChange}
                                            Parametri={Parametri}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 5: //Checkbox
                                    return (
                                        <CampoCheckBox
                                            Id={this._Identificatore + info[I].Campo}
                                            Name={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            Etichetta={info[I].Etichetta}
                                            OnChange={onChange}
                                            Scrittura={abilitato}
                                        />
                                    );
                                case 14: //Anagrafica breve
                                    if (this.props.MaxClient != 1) {
                                        return (
                                            <InputAnagraficaBreve
                                                MaxClient={this.props.MaxClient}
                                                Name={this._Identificatore + info[I].Campo}
                                                Etichetta={info[I].Etichetta}
                                                Id={this._Identificatore + info[I].Campo}
                                                Anagrafiche={Valore}
                                                Parametri={info[I].ParametriJSON}
                                                OnChange={(e, v) => {
                                                    if (datoPolizza.hasOwnProperty("NumeroAssicurati")) {
                                                        onChange(`${this._Identificatore}NumeroAssicurati`, v.length + 1);
                                                    }
                                                    onChange(e, v);
                                                }}
                                                Scrittura={abilitato}
                                            />
                                        );
                                    }
                                    else return;
                                case 15: //testo informativo
                                    return (
                                        <TipoCampoInfo
                                            CampoDatabase={info[I].Campo}
                                            Campo={this._Identificatore + info[I].Campo}
                                            Valore={Valore}
                                            InfoCampo={info[I]}
                                            OnChange={e => onChange(e)}
                                            Richiesto={info[I].Richiesto}
                                            OnChangeDeroga={onChangeDeroga}
                                            Scrittura={abilitato}
                                        />
                                    );
                                default:
                                    return info[I].Campo + " [" + info[I].ID_TipoCampo + "]";
                                //return <TipoCampoStringa OnChange={(e) => onChange(e)} Valore={Valore} InfoCampo={info[I]} />;
                            }
                        })()}
                    </div>
                </div>
            );
        }

        Gruppo.Elementi.push(SottoGruppo);
        AlberoElementi.Elementi.push(Gruppo);

        let wizardTestata: any[] = [];
        let wizardDati: any[] = [];
        let presenzaDati: boolean = false;
        for (let x: number = 0; x < AlberoElementi.Elementi.length; x++) {
            this._WizardSteps = [];

            for (let y: number = 0; y < AlberoElementi.Elementi[x].Elementi.length; y++) {
                const stepName: string = AlberoElementi.Elementi[x].Elementi[y].Nome;

                if (AlberoElementi.Elementi[x].Nome != stepName) {
                    const isStepConfirmed = this.props.ConfirmedSteps ? this.props.ConfirmedSteps.includes(stepName) : true;

                    if (stepName) {
                        presenzaDati = true;
                        this._WizardSteps.push(stepName);
                    }
                    wizardTestata.push(
                        <div className="kt-wizard-v3__nav-item" data-ktwizard-type={"kt_wizard_form_step_" + y} data-ktwizard-state={this.GetStepState(y)} key={x * 10 + y}>
                            <div className="kt-wizard-v3__nav-body">
                                <a
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                    }}
                                    className="kt-wizard-v3__nav-label"
                                >
                                    <span className="kt-wizard__step-label" data-indice={y} onClick={e => this.OnClickWizard(e)}>
                                        {stepName ? Trad.Trad(stepName) : ""}
                                        {this.props.ConfirmedSteps && isStepConfirmed && <i className="la la-check kt-font-success" />}
                                    </span>
                                </a>
                                <div className="kt-wizard-v3__nav-bar" />
                            </div>
                        </div>
                    );

                    wizardDati.push(
                        <div data-ktwizard-state={this.GetStepState(y)} data-ktwizard-type="step-content" id={"kt_wizard_form_step_" + y} key={x * 10 + y}>
                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        <h3>
                                            {stepName ? Trad.Trad(stepName) : ""}
                                            {!isStepConfirmed && (
                                                <button
                                                    type="button"
                                                    className="btn btn-label-danger btn-pill btn-sm kt-margin-l-30"
                                                    data-ktwizard-type="action-next"
                                                    onClick={() => this.OnStepConfirmation(stepName, y)}
                                                >
                                                    {Trad.Trad("Confirm Data")}
                                                </button>
                                            )}
                                        </h3>
                                    </div>
                                    <div className="form-group row">{AlberoElementi.Elementi[x].Elementi[y].Elementi}</div>
                                </div>
                            </div>
                        </div>
                    );
                } else {
                    LC.push(
                        <div className="form-group row" key={riga == undefined ? index : riga}>
                            {AlberoElementi.Elementi[x].Elementi[y].Elementi}
                        </div>
                    );
                }
            }
        }
        if (presenzaDati) {
            LC.push(
                <div className="kt-grid kt-wizard-v3 kt-wizard-v3--white" id="kt_wizard_v3" key={0}>
                    <div className="kt-grid__item">
                        <div className="kt-wizard-v3__nav">
                            <div className="kt-wizard-v3__nav-items">{wizardTestata}</div>
                        </div>
                    </div>

                    <div className="kt-wizard__form spazioVerticale">
                        <div className="" id="kt_form">
                            <div className="kt-portlet__body">{wizardDati}</div>
                        </div>
                    </div>
                </div>
            );
        }

        return LC;
    }

    private OnClickWizard(e: React.FormEvent<any>) {
        this.setState({ CurrentStep: e.currentTarget.getAttribute("data-indice") });
    }

    private GetStepState = (index: number): string => (index == this.state.CurrentStep ? "current" : "pending");

    private GetStepQuestions = (id: string): string[] =>
        Object.keys(this.props.Info).filter(
            (key: string) => this.props.Info[key].SottoGruppo == id && this.props.Info[key].ID_TipoCampo == 13 && this.props.DatoPolizza[key].RispostaAperturaQuestionario
        );

    private OnStepConfirmation = (id: string, index: number) => {
        let confirmedSteps: string[] = this.props.ConfirmedSteps || [];
        let nextStep: number = index;

        if (id == "RischiPattuizioneEspressa") {
            /*console.warn("RischiPattuizioneEspressa", id);*/
            let isStepValid: boolean = true;
            const stepQuestions: string[] = this.GetStepQuestions(id);

            stepQuestions.forEach(question => {
                if (!this.props.DatoPolizza[question].DatiQuestionario.length) {
                    isStepValid = false;
                } else {
                    this.props.DatoPolizza[question].DatiQuestionario.forEach((field: any) => {
                        /*console.warn("fieldValues()", field);*/
                        if (Object.keys(field).length==0) {
                            isStepValid = false;
                        }
                    });
                }
            });

            if (!isStepValid) {
                Glob.InfoModaleWarning("WARNING", Trad.Trad("Fill in the missing fields"));
                return;
            }
        }

        while (nextStep < this._WizardSteps.length - 1) {
            nextStep++;
            if (!confirmedSteps.includes(this._WizardSteps[nextStep])) {
                break;
            }
        }
        this.setState({ CurrentStep: nextStep }, () => this.props.OnStepConfirmation(id));
    };

    private Inizializza(props: ICampiPolizzaProps) {
        this._Abilitato = props.Abilitato != undefined ? props.Abilitato : true;
    }

    public render() {
        this.Inizializza(this.props);
        return this.CreaListaCampi(
            this.props.Info,
            this.props.DatoPolizza,
            this.props.Identificatore,
            this.props.Limiti,
            this.props.OnChange,
            this.props.OnChangeDeroga,
            this.props.OnBlur,
            this.props.Gruppo,
            this._Abilitato,
            this.props.Riga
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CampiPolizza.tsx